/* DARMA set-card add engine — PP1 Phase C round C4 (Jul 2026; PROJECT_STATUS
   item 81, post-C3-preview ruling: R10 SUPERSEDED — set cards add DIRECTLY to
   cart on BOTH surfaces; the ?set= deep-link contract and the builder stay).

   CART CONTRACT = the C3 contract of record VERBATIM (item-77d;
   assets/darma-set-builder.js is the reference implementation): ONE atomic
   POST routes.cart_add_url, JSON items[] with equal variants AGGREGATED into
   quantity, sections cart-drawer,cart-icon-bubble + sections_url,
   X-Requested-With. 422 is ATOMIC (zero partial adds): house error line above
   the CTA (ink text + stock icon; NOT #C7302B) + offending-row tile mark
   (product-title match against the 422 description) + cartError publish.
   Success: cartUpdate publish (source darma-set-card) +
   cart-drawer.renderContents(response) opens the drawer with the automatic
   discount already applied (R5: discounts + titles untouched). No-drawer
   guard -> routes.cart_url redirect. In-flight: aria-disabled + house spinner,
   re-entry guarded per card.

   DELIBERATELY STANDALONE (ratification item in the C4 proposal): this file
   replicates the C3 POST/publish/error flow rather than refactoring the
   probe-verified builder engine into a shared module — the builder ships
   unchanged. The CONTRACT is shared; the implementation is duplicated by
   design. A future divergence between the two files is a bug: change both.

   DATA: each card's data-ds-comp attribute (snippets/darma-set-card.liquid,
   single source of truth — the same resolution pass that renders the visible
   row). Entries: {h,c,a, v} (unsized: v = variant id) or {h,c,a, so,sv}
   (sized: sv = [{s,id,a}]; the chosen size comes from the card's
   server-rendered select — [data-dsc-item] index matches the entry index).
   The select is NEVER rebuilt here (C1.6 class: node persistence = single-tap
   iOS safety by construction). No money math anywhere — the card's Liquid
   renders all prices; the cart is the money of record.

   Gating: the server renders the CTA disabled when any item is unavailable;
   this engine never un-gates it (sold-out sizes are disabled <option>s, so a
   user cannot select one). Homepage note: this file is the ONLY set-JS the
   homepage loads — the full builder engine stays on /pages/sets. */

(function () {
  'use strict';

  if (window.__darmaSetCardAdd) return; /* section renders per instance — one binding */
  window.__darmaSetCardAdd = true;

  var GENERIC = 'Unable to add the set to the cart. Please try again.';

  function cardOf(el) {
    return el.closest('[data-ds-comp]');
  }

  function entriesOf(card) {
    try {
      var e = JSON.parse(card.getAttribute('data-ds-comp'));
      return Array.isArray(e) ? e : null;
    } catch (err) { return null; }
  }

  function showError(card, msg) {
    var errEl = card.querySelector('[data-dsc-error]');
    if (!errEl) return;
    var t = errEl.querySelector('[data-dsc-error-text]');
    if (t) t.textContent = msg; else errEl.textContent = msg;
    errEl.hidden = false;
  }

  function clearError(card) {
    var errEl = card.querySelector('[data-dsc-error]');
    if (errEl) {
      errEl.hidden = true;
      var t = errEl.querySelector('[data-dsc-error-text]');
      if (t) t.textContent = '';
    }
    Array.prototype.slice.call(card.querySelectorAll('.darma-sets__item--error')).forEach(function (row) {
      row.classList.remove('darma-sets__item--error');
    });
  }

  /* offending-row mark: the 422 description names the product — mark every
     item row whose name appears in it (C3 markOffenders parity; cleared on
     any size change or the next attempt) */
  function markOffenders(card, desc) {
    if (!desc) return;
    Array.prototype.slice.call(card.querySelectorAll('.darma-sets__item')).forEach(function (row) {
      var name = row.querySelector('.darma-sets__item-name');
      if (name && desc.indexOf(name.textContent.trim()) !== -1) {
        row.classList.add('darma-sets__item--error');
      }
    });
  }

  /* items[] payload: equal variants aggregated into quantity, first-seen
     order (C3 cartPayload parity). Sized entries read the card's select. */
  function cartPayload(card, entries) {
    var out = [], idx = {};
    for (var i = 0; i < entries.length; i++) {
      var en = entries[i];
      var id = null;
      if (en.sv) {
        var sel = card.querySelector('[data-dsc-item="' + i + '"]');
        var want = sel ? sel.value : null;
        for (var j = 0; j < en.sv.length; j++) {
          if (want == null || en.sv[j].s === want) { id = en.sv[j].id; break; }
        }
      } else if (en.v != null) {
        id = en.v;
      }
      if (id == null) return null; /* malformed entry: refuse to POST a partial set */
      if (idx[id] != null) out[idx[id]].quantity += 1;
      else { idx[id] = out.length; out.push({ id: id, quantity: 1 }); }
    }
    return out.length ? out : null;
  }

  function canPublish() {
    return typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined';
  }

  var cartEl = document.querySelector('cart-drawer');

  function onAdd(btn) {
    var card = cardOf(btn);
    if (!card || card.dataset.dscBusy) return;
    var entries = entriesOf(card);
    if (!entries) return;
    var payload = cartPayload(card, entries);
    if (!payload) return;

    clearError(card);
    card.dataset.dscBusy = '1';
    btn.setAttribute('aria-disabled', 'true');
    btn.classList.add('is-loading');
    var spin = btn.querySelector('.loading__spinner');
    if (spin) spin.classList.remove('hidden');

    var sections = (cartEl && cartEl.getSectionsToRender)
      ? cartEl.getSectionsToRender().map(function (s) { return s.id; })
      : ['cart-drawer', 'cart-icon-bubble'];
    var addUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add.js';

    fetch(addUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: payload,
        sections: sections.join(','),
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) {
          /* 422 — the multi-item add is ATOMIC: nothing was added (77d) */
          var desc = res.description || res.message || (window.cartStrings && window.cartStrings.error) || GENERIC;
          showError(card, desc);
          markOffenders(card, res.description || '');
          if (canPublish()) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'darma-set-card',
              errors: res.errors || res.description,
              message: res.message
            });
          }
          return;
        }
        if (canPublish()) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'darma-set-card', cartData: res });
        }
        if (!cartEl || typeof cartEl.renderContents !== 'function') {
          window.location = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
          return;
        }
        cartEl.setActiveElement(document.activeElement);
        cartEl.renderContents(res); /* drawer opens; discount already applied */
        if (cartEl.classList.contains('is-empty')) cartEl.classList.remove('is-empty');
      })
      .catch(function () {
        showError(card, (window.cartStrings && window.cartStrings.error) || GENERIC);
      })
      .finally(function () {
        delete card.dataset.dscBusy;
        btn.removeAttribute('aria-disabled');
        btn.classList.remove('is-loading');
        if (spin) spin.classList.add('hidden');
      });
  }

  /* document-level delegation: cards exist in multiple section instances on
     both surfaces; nothing per-card to initialize (selects are server DOM) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-dsc-add]');
    if (!btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
    onAdd(btn);
  });

  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-dsc-item]');
    if (!sel) return;
    var card = cardOf(sel);
    if (card) clearError(card); /* a size change invalidates a prior error */
  });

  if (cartEl) {
    Array.prototype.slice.call(document.querySelectorAll('[data-dsc-add]')).forEach(function (b) {
      b.setAttribute('aria-haspopup', 'dialog'); /* product-form parity */
    });
  }
})();
